import React from "react";
import { cn } from "./cn";

/** Subtle shimmering placeholder block. */
export default function Skeleton({ className }) {
  return (
    <span
      className={cn(
        "relative block overflow-hidden rounded-md bg-surface-2",
        "after:absolute after:inset-0 after:-translate-x-full after:animate-[shimmer_1.4s_infinite]",
        "after:bg-gradient-to-r after:from-transparent after:via-line/60 after:to-transparent",
        className
      )}
    />
  );
}
